import type {
  PaymentMethodsProps,
  DealerMethodsPaymentsProps,
  BrandsPaymentsProps,
} from "store/modules/DealerCare/types.store";

function sanitizeBrands(
  brands: BrandsPaymentsProps[] | undefined,
): BrandsPaymentsProps[] {
  if (!Array.isArray(brands)) return [];
  return brands.map((b) => ({
    id: b.id,
    description: b.description,
    imageUrl: b.imageUrl ?? "",
    enabled: Boolean(b.enabled),
  }));
}

function sanitizeMethods(
  methods: DealerMethodsPaymentsProps[] | undefined,
): DealerMethodsPaymentsProps[] {
  if (!Array.isArray(methods)) return [];
  return methods.map((m) => ({
    id: m.id,
    order: m.order,
    description: m.description,
    asksFor: m.asksFor,
    enabled: Boolean(m.enabled),
    brands: sanitizeBrands(m.brands),
  }));
}

export function sanitizePaymentMethodsBrands(
  list: PaymentMethodsProps[] | null | undefined,
): PaymentMethodsProps[] {
  if (!Array.isArray(list)) return [];
  return list.map((pm) => ({
    id: pm.id,
    order: pm.order,
    description: pm.description,
    methods: sanitizeMethods(pm.methods),
  }));
}
